import { motion } from "framer-motion";
import { patents } from "../data/portfolio";

export default function Patents() {
  return (
    <section id="patents" className="section section-narrow">
      <div className="section-header">
        <span className="section-label">Innovation</span>
        <h2>Patents</h2>
      </div>

      <div className="patents-list">
        {patents.map((patent, i) => (
          <motion.article
            key={patent.number}
            className="patent-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.4 }}
          >
            <div className="patent-header">
              <h3>{patent.title}</h3>
              <span className="patent-status">{patent.status}</span>
            </div>
            <p className="patent-inventors">{patent.inventors}</p>
            <div className="patent-footer">
              <span className="patent-number">Patent No: {patent.number} ({patent.year})</span>
              <a href={patent.url} target="_blank" rel="noopener noreferrer" className="patent-link">
                View patent →
              </a>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
